<ngx-spinner bdColor="rgba(51, 51, 51, 0.8)" size="medium" color="#ff9e18" type="ball-fussion"></ngx-spinner>

<div *ngIf="!isLoading" class="maintenance-container">
    <div class="header">
        <img class="sn-logo-yellow" src="assets/images/sn-logo-yellow.svg" alt="smith&nephew logo" title="">
    </div>

    <div class="maintenance-card">
        <div class="icon"></div>

        <h1 class="maintenance-title">Service Temporarily Unavailable</h1>

        <p *ngIf="hil_maintenance_description" class="maintenance-description">
            {{hil_maintenance_description}}
        </p>

        <div *ngIf="hil_maintenance_return_time" class="estimated-return">
            <div class="return-label">Estimated Return:</div>
            <div class="return-time">{{hil_maintenance_return_time}}</div>
            <div class="apology-text">We apologize for any inconvenience this may cause.</div>
        </div>
    </div>
</div>
